import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import gradeService from "../../services/GradeService";

export const getGradeList = createAsyncThunk(
    "grade/getGradeList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await gradeService.GetGradeList();
            return response.data?.ResultSet || response.data?.resultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to get grade list"
            );
        }
    }
);

export const addGrade = createAsyncThunk(
    "grade/addGrade",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await gradeService.AddGrade(payload);
            return response.data?.ResultSet || response.data?.resultSet || response.data || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to add grade"
            );
        }
    }
);

export const updateGrade = createAsyncThunk(
    "grade/updateGrade",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await gradeService.UpdateGrade(payload);
            return response.data?.ResultSet || response.data?.resultSet || response.data || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to update grade"
            );
        }
    }
);

const initialState = {
    grades: [],
    loading: false,
    saving: false,
    error: null,
    success: false,
};

const gradeSlice = createSlice({
    name: "grade",
    initialState,
    reducers: {
        clearGradeError: (state) => {
            state.error = null;
        },

        clearGradeSuccess: (state) => {
            state.success = false;
        },

        clearGrades: (state) => {
            state.grades = [];
        }
    },

    extraReducers: (builder) => {
        builder

        // Get grade list
        .addCase(
            getGradeList.pending,
            (state) => {
                state.loading = true;
                state.error = null;
            }
        )
        .addCase(
            getGradeList.fulfilled,
            (state, action) => {
                state.loading = false;
                state.grades = action.payload;
            }
        )
        .addCase(
            getGradeList.rejected,
            (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to load grades";
            }
        )

        // Add Grade
        .addCase(addGrade.pending, (state) => {
            state.saving = true;
            state.error = null;
            state.success = false;
        })
        .addCase(addGrade.fulfilled, (state) => {
            state.saving = false;
            state.success = true;
        })
        .addCase(addGrade.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to add grade";
        })

        // Update Grade
        .addCase(updateGrade.pending, (state) => {
            state.saving = true;
            state.error = null;
            state.success = false;
        })
        .addCase(updateGrade.fulfilled, (state) => {
            state.saving = false;
            state.success = true;
        })
        .addCase(updateGrade.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to update grade";
        });
    }
});

export const {
    clearGradeError,
    clearGradeSuccess,
    clearGrades
} = gradeSlice.actions;

export default gradeSlice.reducer;
